import {
  Box,
  Button,
  Divider,
  IconButton,
  LinearProgress,
  MenuItem,
  Pagination,
  Popover,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { TEXT_TITLE_COLOR } from '../../constants/colors';
import AddIcon from '@mui/icons-material/Add';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useNotificationControllers } from './controller';
import NotificationForm from './form';
import { AdvertiseModel } from '../../models/advertise';
import { numberFormat } from '../../utils/nunberFormat';
import TableSearchNotFound from '../../components/tableSearchNotFound';
import DeleteIcon from '@mui/icons-material/Delete';
import { convertDateStringToNormalDateTime, convertDateStringToNormalString } from '../../utils/convertDateFormat';
import ConfirmDialog from '../../components/ConfirmDialog';
import { useTranslation } from 'react-i18next';
import LoadingAnimatedIcon from '../../components/loading/loadingAnimated';

const NotificationView = () => {
  const controller = useNotificationControllers();
  const { t } = useTranslation("global");

  return (
    <>
      {controller.openForm ? (
        <NotificationForm onClose={controller.handleCloseForm} onFetchData={controller.handleFetchData} />
      ) : (
        <Box>
          {
            controller.loadingData ?
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <LoadingAnimatedIcon />
              </Box> : <>
                <Typography variant="h4" color={TEXT_TITLE_COLOR} fontWeight="bold">
                  {t("notification_page.Notification managements")}
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'end', mt: 2, mb: 2 }}>
                  <Button
                    variant="contained"
                    sx={{ textTransform: 'none', borderRadius: '10px', ml: 2, background: '#11A2F1' }}
                    onClick={controller.handleOpenForm}
                  >
                    <AddIcon />
                    &nbsp; {t("notification_page.Create Notification")}
                  </Button>
                </Box>
                <Box>
                  <TableContainer>
                    <Table>
                      <TableHead sx={{ background: '#F4F6F8' }}>
                        <TableRow>
                          <TableCell sx={{ borderBottom: 'none' }}>{t("notification_page.No")}</TableCell>
                          <TableCell sx={{ borderBottom: 'none' }}>{t("notification_page.Notification Title")}</TableCell>
                          <TableCell sx={{ borderBottom: 'none' }}>{t("notification_page.Create date")}</TableCell>
                          <TableCell sx={{ borderBottom: 'none' }}>{t("notification_page.Create by")}</TableCell>
                          <TableCell sx={{ borderBottom: 'none' }}>{t("notification_page.Notification Date")}</TableCell>
                          <TableCell sx={{ borderBottom: 'none' }}></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {
                          controller.rows?.map((rows: AdvertiseModel, index: number) => {
                            const { id, title, createByName, createdAt , startDate} = rows;
                            return (
                              <TableRow key={index}>
                                <TableCell sx={{ borderBottom: 'none' }}>
                                  {numberFormat(index + 1 + 10 * (controller.currentPage - 1))}
                                </TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>
                                  {title}
                                </TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>
                                  {convertDateStringToNormalString(createdAt)}
                                </TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>
                                  {createByName}
                                </TableCell>
                                <TableCell sx={{ borderBottom: 'none' }}>
                                  {startDate}
                                </TableCell>
                                <TableCell sx={{ borderBottom: 'none' }} align="right">
                                  <IconButton size="large" color="inherit" onClick={(e: any) => controller.handleOpenMenu(e, id)}>
                                    <MoreHorizIcon />
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            )
                          })
                        }
                      </TableBody>
                      {
                        controller.isSearchNotFound && (
                          <TableSearchNotFound
                            searchValue={controller.searchValue}
                            colSpan={5}
                          />
                        )
                      }
                    </Table>
                  </TableContainer>
                  <Divider sx={{ mt: 1, mb: 1 }} />
                  <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                    <Pagination
                      color="primary"
                      count={controller.countPagination}
                      page={controller.currentPage}
                      onChange={controller.handleChangePage}
                    />
                  </Box>
                </Box>
                <Popover
                  open={Boolean(controller.openMenu)}
                  anchorEl={controller.openMenu}
                  onClose={controller.handleCloseMenu}
                  anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                  transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                  PaperProps={{
                    sx: {
                      p: 1,
                      width: 140,
                      '& .MuiMenuItem-root': {
                        px: 1,
                        typography: 'body2',
                        borderRadius: 0.75,
                      },
                    },
                  }}
                >
                  <MenuItem onClick={() => controller.handleOpenDeleteForm()} >
                    <DeleteIcon />
                    &nbsp;&nbsp; {t("Delete")}
                  </MenuItem>
                </Popover>
                <ConfirmDialog
                  open={controller.openDeleteForm}
                  title={t("Do you want to delete this Data ?")}
                  loading={controller.loadingButton}
                  onCancel={controller.handleCloseDeleteForm}
                  onConfirm={() => controller.handleDeleteNotification()}
                />
              </>
          }
        </Box>
      )}
    </>
  );
};
export default NotificationView;
